export enum Type {
	SECONDS = 'SECONDS',
	MINUTES = 'MINUTES',
	HOURS = 'HOURS',
	DAY = 'DAY',
	MONTH = 'MONTH',
	YEAR = 'YEAR'
}
